import { uid } from 'quasar'
import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import Crypto from 'crypto-js'
import Cookie from 'js-cookie'

import activities from './activities'
import activities_live_class from './activities_live_class'
import activities_presential from './activities_presential'
import activities_webinar from './activities_webinar'
import common from './common'
import courses from './courses'
import events from './events'
import faq from './faq'
import global_search from './global_search'
import library from './library'
import live_classes from './live_classes'
import news from './news'
import notifications from './notifications'
import offline_course from './offline_course'
import params from './params'
import portfolio from './portfolio'
import podcasts from './podcasts'
import presentials from './presentials'
import redirect from './redirect'
import reward_store from './reward_store'
import site_lists from './site_lists'
import trails from './trails'
import user from './user'
import webinars from './webinars'
import welcome_banner from './welcome_banner'
import cookies_policy from './cookies_policy'
import utils from './utils'

const cookie_name = process.env.PROJECT_FOLDER
const storage_key = process.env.PROJECT_FOLDER
const encryption_token = Cookie.get(cookie_name) || uid()

Cookie.set(cookie_name, encryption_token, { secure: true, expires: 180 })

const vuex_local = new VuexPersistence({
	storage: {
		getItem: () => {
			const store = window.localStorage.getItem(storage_key)
			if (store) {
				try {
					const bytes = Crypto.AES.decrypt(store, encryption_token)
					return JSON.parse(bytes.toString(Crypto.enc.Utf8))
				} catch (e) {
					window.localStorage.removeItem(storage_key)
				}
			}
			return null
		},
		setItem: (key, value) => {
			const store = Crypto.AES.encrypt(value, encryption_token).toString()
			return window.localStorage.setItem(storage_key, store)
		},
		removeItem: () => window.localStorage.removeItem(storage_key),
	},
	reducer: (state) => ({
		common: state.common,
		offline_course: state.offline_course,
		params: state.params,
		site_lists: state.site_lists,
		welcome_banner: state.welcome_banner,
		cookies_policy: state.cookies_policy,
	}),
})

const store = createStore({
	modules: {
		activities,
		activities_live_class,
		activities_presential,
		activities_webinar,
		common,
		courses,
		events,
		faq,
		global_search,
		library,
		live_classes,
		news,
		notifications,
		offline_course,
		params,
		podcasts,
		portfolio,
		presentials,
		redirect,
		reward_store,
		site_lists,
		trails,
		user,
		webinars,
		welcome_banner,
		cookies_policy,
		utils,
	},
	strict: process.env.DEBUGGING,
	plugins: [vuex_local.plugin],
})

export default store
